/* eslint-disable import/no-cycle */
import ajax from '../../../../utils/ajax';

export default (url, data, method, callback, isAnonymous, aip = 'platform') => {
	return ajax(url, data, method, callback, isAnonymous, aip);
};
